/** Shared Bootstrap form-check alignment for work opening notice forms */
export const wonFormCheckRow = 'form-check d-flex align-items-center gap-2 mb-0'
export const wonFormCheckInput = 'form-check-input mt-0 flex-shrink-0'
export const wonFormCheckLabel = 'form-check-label text-gray-800 ps-0 mb-0'
